// LoadingSpinner.js
import React from "react";

function LoadingSpinner() {
  return (
    <div className="loading-spinner" id="loader">
      <div></div><div></div><div></div><div></div>
    </div>
  );
}

export default LoadingSpinner;
